import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './assets/css/styles.css';
import AppShell from './components/AppShell';
import IndexPage from './pages/index';
import TermsOfService from './pages/terms-of-service.js';
import PrivacyPolicy from './pages/privacy-policy.js';
import reportWebVitals from './reportWebVitals';
import Manual from './pages/manual';
import Login from './pages/login';
import Portal from './pages/portal';
import Videos from './pages/videos';
import Store from './pages/store';
import StoreSuccess from './pages/store-success';
import MembershipSuccess from './pages/membership-success';
import GearPage from './pages/gear';
import LoxAndLoaded from './pages/lox-and-loaded';
import LoxAndLoadedSuccess from './pages/lox-and-loaded-success';
import ShotDiagnostics from './pages/shot-diagnostics';
import Register from './pages/register';
import ForgotPassword from './pages/forgot-password';
import ResetPassword from './pages/reset-password';
import ConsoleLayout from './pages/console-layout';
import Console from './pages/console';
import ConsoleCatalog from './pages/console-catalog';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <AppShell>
          <Routes>
            <Route path="/" element={<IndexPage />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/manual" element={<Manual />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/portal" element={<ProtectedRoute><Portal /></ProtectedRoute>} />
            <Route path="/console" element={<ProtectedRoute><ConsoleLayout /></ProtectedRoute>}>
              <Route index element={<Console />} />
              <Route path="catalog" element={<ConsoleCatalog />} />
            </Route>
            <Route path="/videos" element={<ProtectedRoute><Videos /></ProtectedRoute>} />
            <Route path="/store" element={<ProtectedRoute><Store /></ProtectedRoute>} />
            <Route path="/store/success" element={<ProtectedRoute><StoreSuccess /></ProtectedRoute>} />
            <Route path="/membership/success" element={<ProtectedRoute><MembershipSuccess /></ProtectedRoute>} />
            <Route path="/gear" element={<GearPage />} />
            <Route path="/lox-and-loaded" element={<LoxAndLoaded />} />
            <Route path="/lox-and-loaded/success" element={<LoxAndLoadedSuccess />} />
            <Route path="/shot-diagnostics" element={<ShotDiagnostics />} />
          </Routes>
        </AppShell>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
